const initialState = {
  active: true,
  contract: {
    end: '',
    informed: false,
    msisdn: ''
  },
  contractHolder: {
    gender: '',
    firstName: '',
    lastName: '',
    birthDate: ''
  },
  mnpProviders: null,
  mnpProvidersLastLoadAttempt: null,
  mnpProvidersLoadingStatus: '',
  prepaidModalPassed: null,
  provider: {
    brandName: '',
    code: '',
    key: '',
    network: '',
    prepaid: false,
    relatedTariff: null,
    unportable: false
  },
  simType: null
}

const CheckoutMNPDataModule = {
  namespaced: true,
  state: initialState,
  getters: {
    active: (state) => {
      return state.active
    },
    provider: (state) => {
      return state.provider
    },
    providerKey: (state) => {
      return state.provider?.key
    },
    providerCode: (state) => {
      return state.provider?.code
    },
    unportable: (state) => {
      return state.provider?.unportable
    },
    prepaid: (state) => {
      return state.provider?.prepaid
    },
    contract: (state) => {
      return state.contract
    },
    contractMsisdn: (state) => {
      return state.contract.msisdn
    },
    mnpProvidersLoadingStatus: (state) => {
      return state.mnpProvidersLoadingStatus
    },
    mnpProviders: (state) => {
      return Object.values(window.$gqlpre.mnpProvidersWithTariffs)
    },
    portabilityCore: (state) => {
      if (state.active && state.provider?.code && state.provider?.key && !state.provider?.unportable) {
        return {
          networkKey: state.provider.network,
          portingDateType: state.contract.end,
          portingMsisdn: state.contract.msisdn,
          providerKey: state.provider.key
        }
      } else {
        return {}
      }
    },
    contractHolder: (state) => {
      return state.contractHolder
    },
    portationCore: (state) => {
      if (state.active && state.provider?.code && state.provider?.key && !state.provider?.unportable) {
        return {
          msisdn: state.contract.msisdn,
          network: state.provider.network,
          provider: state.provider.key,
          executionDate: state.contract.end
        }
      } else {
        return {}
      }
    },
    prepaidModalPassed: (state) => {
      return state.prepaidModalPassed
    },
    simType: (state) => {
      return state.simType
    }
  },
  actions: {
    async getProviderList ({ state, commit, rootGetters }) {
      // initialize
      commit('clearMessages', {}, { root: true })
      // check for prefetched data
      if (state.mnpProvidersLoadingStatus !== 'LOADED') {
        if (typeof window.$gqlpre.mnpProvidersWithTariffs !== 'undefined') {
          const data = Object.values(window.$gqlpre.mnpProvidersWithTariffs)
          commit('storeMNPProviderWithTariffs', data)
          commit('storeMNPProviderLoadingStatus', 'LOADED')
        } else {
          commit('storeMNPProviderLoadingStatus', 'ERROR')
        }
      }
    },
    async validate ({ dispatch, commit, state, getters, rootGetters }, { active, provider, contract, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('storeActive', active)
      commit('storeProvider', provider)
      commit('storeContract', contract)

      let hasErrors = false
      if (active) {
        if (!provider?.brandName || !provider?.key || !provider?.code || !provider?.relatedTariff) {
          commit('addError', 'Bitte wählen deinen bisherigen Mobilfunkanbieter aus', { root: true })
          hasErrors = true
        }
        if (contract?.msisdn === '') {
          commit('addError', 'Du musst deine aktuelle Rufnummer eingeben', { root: true })
          hasErrors = true
        }
        if (contract?.end === '') {
          commit('addError', 'Du musst dein Vertragsende auswählen', { root: true })
          hasErrors = true
        }
        if (!provider?.prepaid && !contract?.informed) {
          commit('addError', 'Du musst bestätigen dass Du deinen aktuellen Anbieter informiert hast', { root: true })
          hasErrors = true
        }
      }

      if (!hasErrors) {
        commit('checkout/goToStep', nextStep, { root: true })
      }
    },
    async updateActive ({ dispatch, commit, state, getters, rootGetters }, { active }) {
      commit('storeActive', active)
    },
    async updateProvider ({ dispatch, commit, state, getters, rootGetters }, { active, provider }) {
      commit('storeActive', active)
      commit('storeProvider', provider)
    },
    async updateContractHolder ({ dispatch, commit, state, getters, rootGetters }, { contractHolder }) {
      commit('storeContractHolder', contractHolder)
    },
    resetMNPDefaultState ({ commit, state }) {
      // initialize
      commit('clearMessages', {}, { root: true })
      commit('resetState', state)
    }
  },
  mutations: {
    storeActive (state, active) {
      state.active = active
    },
    storeProvider (state, provider) {
      state.provider = {
        brandName: (typeof provider !== 'undefined' && provider !== null) ? provider?.brandName : null,
        network: (typeof provider !== 'undefined' && provider !== null) ? provider?.network : null,
        key: (typeof provider !== 'undefined' && provider !== null) ? provider?.key : null,
        code: (typeof provider !== 'undefined' && provider !== null) ? provider?.code : null,
        relatedTariff: (typeof provider !== 'undefined' && provider !== null) ? provider?.relatedTariff : null,
        unportable: (typeof provider !== 'undefined' && provider !== null) ? provider?.unportable : null,
        prepaid: (typeof provider !== 'undefined' && provider !== null) ? provider?.prepaid : null
      }
    },
    storeContract (state, contract) {
      state.contract = {
        msisdn: (contract !== null) ? contract?.msisdn.replace(/([^0-9+])/g, '').trim() : null,
        end: (contract !== null) ? contract?.end : null,
        informed: (contract !== null) ? contract?.informed : null
      }
    },
    storeMNPProviderLoadingStatus: (state, status) => {
      state.mnpProvidersLoadingStatus = status
    },
    storeMNPProviderWithTariffs: (state, data) => {
      state.mnpProviders = data
    },
    storeContractHolder: (state, data) => {
      state.contractHolder = data
    },
    storePrepaidModalPassed: (state, status) => {
      state.prepaidModalPassed = status
    },
    resetState (state) {
      Object.assign(state, initialState)
    },
    storeSimType (state, simType) {
      state.simType = simType
    }
  }
}

export default CheckoutMNPDataModule
